import MenuOrderV2 from './MenuOrderV2';

export default MenuOrderV2;
